module.exports = __webpack_public_path__ + "static/media/masthead-bunbury-herald.2c928af1.svg";